import { render, staticRenderFns } from "./ProjectDataComponent.vue?vue&type=template&id=dccc8890&"
import script from "./ProjectDataComponent.vue?vue&type=script&lang=js&"
export * from "./ProjectDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports